<template lang="pug">
  div#questionlist
    empty-list-placeholder(
      v-if="showEmpty"
    )

    el-col#question-items(
      v-if="questionList.length > 0"
      :class="{'question-items-full': isGraded, 'question-items-part': !isGraded}"
    )
      // Questions list items
      question-placeholder(
        :id="question.id"
        :questionData="question"
        :index="currentIndex+1"
        :totalCount="questionList.length"
        :isGraded="isGraded"
        @questionSubmitted="markQuestion"
        style="margin-left: 2%;")

    // Side panel Question No. Navigation
    div(v-if="!isGraded")
      el-col#question-tab-col(style="width: 12.5%; padding-bottom: 4%;")
        div(style="min-height: 100px;")
          div#question-tabs(
            v-for="item, index in questionList" v-model="questionList"
            :class="{'answered-question-tab':  item.isAnswered, 'current-question-tab': currentIndex === index,'normal-question-tab': !item.isAnswered && currentIndex != index}"
            @click="showQuestion(index)")
            span(
              :ref="index") Q{{ index + 1 }}
                            
        // Quiz Submit, Reset buttons
        div#question-buttons
          el-button(
            v-if="!isSubmitted && questionList.length > 0 && isGraded"
            type="primary"
            style="margin-top: 25px; width: 100%; min-height: 40px;  font-size: 16px;"
            @click="finishQuiz")
              small End Quiz

</template>

<script>
  import QuestionPlaceholder from '@/components/student/Question/Placeholder/QuestionPlaceholder'
  import EmptyListPlaceholder from '@/components/student/Question/Placeholder/EmptyPlaceholder'
  import { setTimeout } from 'timers'
  import utilMixin from '@/components/mixins/utilMixin'


  export default {
    name: 'QuestionList',

    components: {
      QuestionPlaceholder,
      EmptyListPlaceholder,
    },

    mixins: [utilMixin],

    props: {
      quizData: {
        type: Object,
        required: true,
      },
    },

    data () {
      return {
        currentIndex: -1,
        countAnswered: 0,
        quizScore: 0,
        totalScore: 0,
        isSubmitted: false,
        showEmpty: false,
        controlPanelVisibility: 'visible',
        question: {},
        questionList: [],
      }
    },

    computed: {
      isGraded() {
        return this.$store.state.quizData.isGraded
      },
    },

    watch: {
      quizData() {
        this.refreshList()
      },
    },

    methods: {
      refreshList() {
        this.$emit('onProcessing', true)
        this.axios.get('/api/quiz/' + this.quizData.id + '/question')
          .then((result) => {
            this.questionList = []
            result.data.object.forEach((item, index) => {
              item['isAnswered'] = false
              this.questionList.push(item)
              this.totalScore += item.score
            })

            if (this.questionList.length === 0) {
              this.showEmpty = true
            }

            this.$emit('onProcessing', false)
            this.currentIndex = 0
            this.question = this.questionList[0]
          })
          .catch((error) => {
            this.showEmpty = true
            this.$store.state.quizData = {}
            this.mNotification({error: error, message: 'Your Question list was not fully retrieved.'})
          })
      },

      showQuestion(id) {
        this.question = this.questionList[id]
        this.currentIndex = id
      },

      submitQuiz() {
        this.isSubmitted = true
        this.axios.post('/api/quiz/' + this.$store.state.quizData.id + '/submit')
          .then((result) => {
            this.countAnswered = 0
            this.$emit('onProcessing', false)
            if (!result.data.isUpdated) {
              this.mNotification( {error: 'Grade submit error', message: result.data.message})
            }
            this.backToCoursePage()
          })
          .catch((error) => {
            this.$emit('onProcessing', false)
            this.mNotification({error: error, message: 'There was an error submitting your quiz score.'})
          })
      },

      backToCoursePage() {
        const parentUrl = (window.location != window.parent.location)
              ? document.referrer
              : document.location.href

        const isModule = (parentUrl.indexOf('module_item_id') >= 0) || (parentUrl.indexOf('/modules') >= 0)
        const { courseId, launchUrl } = this.$store.state.canvasData
        const subMessage = this.$store.state.quizData.isEnrolled? 
          'Your grade has been recorded in Canvas' :
          'Please enroll in this course to record your grade.'

        this.$alert(`<strong>You scored ${this.quizScore} / ${this.totalScore}.</strong><br>${subMessage}`, 'Quiz Completed', {
          confirmButtonText: `Back to ${isModule?'Modules':'Assignments'}`,
          dangerouslyUseHTMLString: true,
          callback: action => {
            window.parent.location = `${launchUrl}/courses/${courseId}/` + (isModule? 'modules': 'assignments')
          },
        })
      },

      finishQuiz() {
        this.questionList.forEach((item, index) => {
          if (!item.isAnswered) {
            this.countAnswered += 1
            item.isAnswered = true
          }
        })

        if (!this.isSubmitted) {
          this.finalizeQuiz()
        } else {
          this.$alert('<p>Please refresh this page or re-launch the LTI app to allow score re-submission.</p>', 'Information', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'OK',
            type: 'info',
          })
        }
      },

      finalizeQuiz() {
        if (this.countAnswered === this.questionList.length) {
          if (this.isGraded) {
            this.$emit('onProcessing', true)
            this.submitQuiz()
          } else {
            this.isSubmitted = true
            this.countAnswered = 0
          }
        }
        else if(this.isGraded ) {
          setTimeout(()=>{
            this.showQuestion(this.currentIndex+1)
          },2500)
        }
      },

      markQuestion(obj) {
        for (let i=0; i<this.questionList.length; i += 1) {
          if (this.questionList[i].id === obj.id && !this.questionList[i].isAnswered) {
            this.questionList[i].isAnswered = true
            this.countAnswered += 1
            this.quizScore += obj.score
            break
          }
        }
        this.question.isAnswered = true
        this.finalizeQuiz()
      },
    },
  } 
</script>

<style module>
  #questionlist {
    width: 100%;
    margin: auto;
  }

  #question-tab-col {
    text-align: center;
    vertical-align: middle;
    margin-left: 1.25%;
  }
  
  #question-items {
    display: flex; 
    flex-direction: column; 
    justify-content: flex-start;
  }
  .question-items-full {
    width: 98%;
  }

  .question-items-part {
    width: 84%;
    margin-left: 0.5%;
  }

  #question-tabs {
    text-align: center;
    padding: 10%;
    margin-bottom: 2%;
    cursor: pointer;
    border: 1px solid #f1f1f1; border-radius: 7px;
  }

  #question-tabs div {
    margin: 5%;    
  }

 #question-tabs:hover {
    background-color: #eeeeee;
    border-radius: 5px;
  }

  .current-question-tab{
    font-weight: bold;
    border-radius: 5px;
    color: #fff !important;
    background-color: #409EFF !important;
  } 

  .normal-question-tab {
    color: #606266;
    font-weight: normal;
  
  }

  .answered-question-tab {
    color: #388e3c;
    font-weight: bold;
  }
</style>